// extracted by mini-css-extract-plugin
export default {"boxcontainer":"navbar_boxcontainer__MB0BJ","userDetail":"navbar_userDetail__Ay988","fullname":"navbar_fullname__U7WK8","username":"navbar_username__sOWuF"};